import icon from "../../assets/icons/arrow-left.svg";
import { Link, useNavigate } from "react-router-dom";

const TitleBar = ({ url, cta, title, children, clickOverride, goBack }) => {
    const navigate = useNavigate();
    cta = cta || "Back";

    const handleClick = (e) => {
        if (goBack) {
            e.preventDefault();
            navigate(-1);
            return;
        }
        if (clickOverride) {
            clickOverride(e);
        }
    };

    if (url || document.referrer || goBack) {
        return (
            <section className="title-bar">
                <Link to={goBack ? "#" : url || document.referrer} className="title-bar__link" onClick={handleClick}>
                    <img src={icon} alt="" />
                    <span className="title-bar__link__text">{cta}</span>
                </Link>
                <div className="title-bar__title-tabs-wrapper">
                    {children ? children : <h1 className="title-bar__title">{title}</h1>}
                </div>
            </section>
        );
    }
};

export default TitleBar;
